import Keycloak from 'keycloak-js';
import React, { ReactNode, createContext, useEffect, useState } from 'react';
import { JWTDecoded } from '../components/Dashboard/IDashboard';
import jwtDecode from 'jwt-decode';

import { IStore, UserRoleEnums } from '../redux/store/IStore';
import { config } from '../config';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../redux/actions/actions';

export interface IKeycloakAuthProps {
  children: ReactNode;
}
interface IKeycloakAuthContext {
  isAuthenticated: boolean;
}
const KeycloakAuthContext = createContext<IKeycloakAuthContext>({
  isAuthenticated: false,
});

const { keycloakUrl, publicUrl, keycloakClientId, keycloakAuthReam, keycloakIdpAlias } = config;

export const keycloak = new Keycloak({
  url: `${keycloakUrl}`,
  realm: keycloakAuthReam,
  clientId: keycloakClientId,
});

export const KeycloakAuthProvider: React.FC<IKeycloakAuthProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const dispatch = useDispatch();
  const user = useSelector((state: IStore) => state.user);

  useEffect(() => {
    if (keycloak.token && user) {
      dispatch(
        setUser({
          username: user.username,
          isAuthenticated: user.isAuthenticated,
          accessToken: keycloak.token,
          refreshToken: keycloak.refreshToken,
          userRoles: user.userRoles,
          isEditorUser: user.isEditorUser,
          idToken: keycloak.idToken,
          group: user.group,
        })
      );
    }
  }, [keycloak.token]);

  useEffect(() => {
    const wrapper = async () => {
      if (keycloak.authenticated) {
        setIsAuthenticated(true);
      } else {
        try {
          const response = await keycloak.init({
            checkLoginIframe: false,
            //onLoad: 'login-required'
            redirectUri: publicUrl,
          });

          if (!response) {
            const queryParamAdmin = new URL(document.location.href).searchParams.get('isLocalUser');
            const isAdmin = queryParamAdmin && queryParamAdmin === 'true';

            keycloak.login({ redirectUri: publicUrl, idpHint: isAdmin ? undefined : keycloakIdpAlias });
            return;
          }

          if (keycloak.token) {
            const decodedTokenData: JWTDecoded = jwtDecode(keycloak.token);
            const user = {
              username: decodedTokenData.preferred_username,
              accessToken: keycloak.token,
              refreshToken: keycloak.refreshToken,
              isAuthenticated: true,
              userRoles: decodedTokenData.realm_access.roles,
              isEditorUser: decodedTokenData.realm_access.roles.includes(UserRoleEnums.EDITOR_USER),
              idToken: keycloak.idToken,
              group: '',
            };
            console.log('USER');
            console.log(user);
            dispatch(setUser(user));
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    wrapper();
  }, []);

  return <KeycloakAuthContext.Provider value={{ isAuthenticated }}>{children}</KeycloakAuthContext.Provider>;
};

export default KeycloakAuthContext;
